/* @jsxImportSource react */

import type { PropsWithChildren } from 'react';

export const BreadcrumbsWrapper = ({ children }: PropsWithChildren) => (
  <div className="w-full py-1">{children}</div>
);
